import { render } from "./pagesix.vue?vue&type=template&id=2bc4fe18"
import script from "./pagesix.vue?vue&type=script&lang=js"
export * from "./pagesix.vue?vue&type=script&lang=js"

import "./pagesix.vue?vue&type=style&index=0&id=2bc4fe18&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__